import React, { useState } from 'react';

import { House ,ChevronRight, Minus, Plus  } from 'lucide-react';

const faqData = [
    {
        id: 'faq-1',
        question: 'What kind of sarees does Tanuraaga offer?',
        answer: 'Tanuraaga mainly curates women’s Indian-style sarees for festivals, weddings, family occasions, rituals, and graceful everyday wear. Each saree is selected for its drape, fabric feel, color, and occasion suitability.',
    },
    {
        id: 'faq-2',
        question: 'Will the saree color look exactly like the photos?',
        answer: 'We try to show saree colors as accurately as possible, but slight variation may happen because of lighting, photography, zari shine, fabric texture, and your device screen settings.',
    },
    {
        id: 'faq-3',
        question: 'Does the saree include a blouse piece?',
        answer: 'Blouse piece availability depends on the product. Please check the product details before ordering. If a blouse piece is included, it should be returned along with the saree for eligible return or refund requests.',
    },
    {
        id: 'faq-4',
        question: 'How long does delivery take?',
        answer: 'Delivery timelines depend on your location, courier availability, and order confirmation. Once your order is processed, we will share shipping updates through the contact details provided during checkout.',
    },
    {
        id: 'faq-5',
        question: 'Do you support Cash On Delivery?',
        answer: 'Cash On Delivery may be available for selected locations or orders. If COD is available, it will be shown during checkout. Tanuraaga may verify COD orders before dispatch.',
    },
    {
        id: 'faq-6',
        question: 'Can I return or exchange a saree?',
        answer: 'Returns or exchanges are accepted only when the saree meets our policy conditions, such as wrong product, damaged item, or manufacturing defect reported within the return window. Used, washed, altered, fall/pico completed, or blouse-stitched sarees are not eligible.',
    },
    {
        id: 'faq-7',
        question: 'How do I report a damaged or wrong product?',
        answer: 'Please contact us with your order number, product photos, packaging photos, and invoice details as soon as possible. This helps our team verify the issue and guide you through the refund or exchange process.',
    },
    {
        id: 'faq-8',
        question: 'How should I care for my saree?',
        answer: 'Care depends on the fabric and work. As a safe practice, avoid harsh washing, direct prolonged sunlight, and strong chemicals. Delicate sarees, zari work, and festive pieces are best handled with dry clean or gentle professional care.',
    },
    {
        id: 'faq-9',
        question: 'How can I reset my account password?',
        answer: 'Go to the login page and click “Forgot Password”. You can request an OTP on your registered email, verify it, and then set a new password.',
    },
    {
        id: 'faq-10',
        question: 'How can I contact Tanuraaga support?',
        answer: 'You can reach us at tanuraaga.weaves@gmail.com or +91 7411134054. For order-related support, please keep your order number and registered contact details ready.',
    },
];


const FAQItem = ({ question, answer, isOpen, toggleFAQ }) => {
    return (
        <div className={`faq-page-item ${isOpen ? 'faq-page-item-open' : ''}`}>
            <button 
                className="faq-page-question-button" 
                onClick={toggleFAQ}
                aria-expanded={isOpen}
            >
                <h3 className="faq-page-question">{question}</h3>
                <span className="faq-page-toggle-icon">
                   
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />} 
                </span>
            </button>
            <div 
                className={`faq-page-answer-container ${isOpen ? 'faq-page-answer-open' : ''}`}
                style={{ maxHeight: isOpen ? '200px' : '0' }} 
            >
                <p className="faq-page-answer">{answer}</p>
            </div>
        </div>
    );
};



const FAQPage = () => {
    const [openFAQId, setOpenFAQId] = useState(null);

    const toggleFAQ = (id) => {
        setOpenFAQId(openFAQId === id ? null : id);
    };

    return (
        <div className="faq-page-container">
           
        
   <div className="terms-condition-page-header-banner">
        <h1 className="terms-condition-page-title">FAQs</h1>
        <div className="terms-condition-page-breadcrumb">
       <House className="terms-condition-page-home-icon" />
          <span className="terms-condition-page-breadcrumb-item">Home</span>
          <span className="terms-condition-page-breadcrumb-separator"><ChevronRight className="terms-condition-page-home-arrowicon" /></span>
          <span className="terms-condition-page-breadcrumb-item terms-condition-page-breadcrumb-active">FAQs</span>
        </div>
      </div>
          
            <main className="faq-page-main-layout">
                <div className="faq-page-content-wrapper">
                    {faqData.map(faq => (
                        <FAQItem
                            key={faq.id}
                            question={faq.question}
                            answer={faq.answer}
                            isOpen={openFAQId === faq.id}
                            toggleFAQ={() => toggleFAQ(faq.id)}
                        />
                    ))}
                </div>
            </main>
        </div>
    );
};

export default FAQPage;
